export default __webpack_public_path__ + "static/signature-6a544be54858edd64f9dffbb5f354b03.png";